module.exports = __webpack_public_path__ + "media/images/mobile-only/el-2-68bda2813648446acf3a8a0c6b29365d.png";